import * as types from '../constants/ActionTypes';

export const agregarContraventor = contraventor => dispatch => {
  // console.log("Contraventor en el action: ");
  // console.log(contraventor)
  dispatch({
    type: types.AGREGAR_CONTRAVENTOR,
    payload: {
      contraventor,
    },
  });
};

export const agregarContraventores = contraventores => dispatch => {
  // console.log("Contraventor en el action: ");
  // console.log(contraventores)
  dispatch({
    type: types.SET_CONTRAVENTORES,
    payload: {
      contraventores,
    },
  });
};

export const sacarContraventor = _id => dispatch => {
  dispatch({
    type: types.ELIMINAR_CONTRAVENTOR,
    payload: {
      _id,
    },
  });
};

// eslint-disable-next-line no-unused-vars
export const getContraventores = contraventor => dispatch => {
  dispatch({
    type: types.GET_CONTRAVENTORES,
  });
};

export const setContraventores = contraventores => dispatch => {
  dispatch({
    type: types.SET_CONTRAVENTORES,
    payload: {
      contraventores,
    },
  });
};

export const cambiarRol = (idContraventor, rol) => dispatch => {
  dispatch({
    type: types.CAMBIAR_ROL,
    payload: {
      idContraventor,
      rol,
    },
  });
};
